import _, { toInteger } from 'lodash';

// Ordered list of top makes
const TOP_MAKES = ['CITROEN', 'FORD', 'HONDA', 'MERCEDES', 'NISSAN', 'PEUGEOT', 'RENAULT',
    'TOYOTA', 'VAUXHALL', 'VOLKSWAGEN'];

function clearVehicleProperties(vehicle, properties) {
    if (vehicle) {
        _.each(properties, (property) => {
            // eslint-disable-next-line no-param-reassign
            vehicle[property].value = undefined;
        });
    }
}

function clearVehicleLookup(vehicle) {
    // eslint-disable-next-line no-param-reassign
    vehicle.isRegKnown.value = false;
    clearVehicleProperties(vehicle, ['registrationNumber', 'year', 'make', 'model', 'bodyType', 'engineCapacity', 'transmission',
        'numberOfDoors', 'description', 'abiNumber', 'vehicleRatingGroup', 'motorhomeEngineCapacity',
        'vehicleValue', 'isTrackerInstalled', 'yearPurchased', 'hasModifications']);
}

function abiCarComparator(abiCar1, abiCar2) {
    if (abiCar1.description > abiCar2.description) {
        return 1;
    } if (abiCar1.description < abiCar2.description) {
        return -1;
    }
    return 0;
}

function getFilter(properties) {
    const result = {};
    result.make = properties.make;
    result.model = properties.model;
    if (properties.numberOfDoors) {
        result.numberOfDoors = toInteger(properties.numberOfDoors);
    }
    if (properties.transmission) {
        result.transmission = properties.transmission;
    }
    if (properties.engineCapacity) {
        result.engineCapacity = toInteger(properties.engineCapacity);
    }
    return result;
}

function updateFilteredAbiCars(abiCars, vehicleModel) {
    const filteredAbiCars = _.filter(abiCars, getFilter(vehicleModel.value));
    filteredAbiCars.sort(abiCarComparator);
    return filteredAbiCars;
}

function extractTopMakes(makes) {
    const result = {
        topMakes: [],
        allMakes: []
    };
    _.each(makes, (make) => {
        const topIndex = _.indexOf(TOP_MAKES, make.name.toUpperCase());
        // Push all makes inc top 10 to all makes list
        result.allMakes.push(make);
        // Filter top 10 makes and add to top makes list
        if (topIndex !== -1) {
            result.topMakes.push(make);
        }
    });
    result.topMakes = _.sortBy(result.topMakes, 'name'); // Sort top makes
    result.allMakes = _.sortBy(result.allMakes, 'name'); // Sort remaining makes alphabetically
    return result;
}

export default {
    clearVehicleProperties,
    clearVehicleLookup,
    updateFilteredAbiCars,
    extractTopMakes
};
